<div *ngIf="this.isLoading" class="progress-spinner">
	<p-progressSpinner></p-progressSpinner>
</div>
<app-add-coment-dialog
	(commentDialogClose)="this.onDialogClose()"
	[currentFile]="this.primaryFile"
	[isVisible]="this.isCommentDialogVisible"
	[processId]="this.processId"
	[taskType]="WorkflowType.Daily"
></app-add-coment-dialog>

<div class="grid container align-center">
	<div [class]="this.pdfCss">
		<div class="card-task-detail relative">
			<app-task-report-panel
				[currentTask]="currentTask"
				[isLoading]="isLoading"
				[isPrimary]="true"
				[isSubmitDisabled]="isSubmitting"
				[viewerPanelInFocus]="pdfPanelInFocus"
				[viewerAvailability]="reportViewerAvailability"
				[activeViewer]="activeReportViewer"
				[fallbackBackUrl]="'/tasks'"
				[isPhobosTask]="false"
				(nextRequested)="goToNextTask()"
				(previousRequested)="goToPreviousTask()"
				(reviewRequested)="onReview()"
			>
				<app-pdf-file-panel
					*ngIf="activeReportViewer === 'pdf'"
					(uploadFile)="uploadWorkflowFile($event)"
					[containerId]="mainPdfContainer"
					[currentFile]="primaryFile"
					[currentTask]="currentTask"
					[hasPdfReport]="primaryFile.documentId !== undefined"
					[isLoading]="isLoading"
					[isPrimary]="true"
				></app-pdf-file-panel>
			</app-task-report-panel>
		</div>
	</div>

	<div class="flex justify-content-center mx-3 pt-5">
		<div class="hidden lg:block">
			<app-round-button-left
				(LeftClick)="getOpenComment()"
				[hidden]="!this.pdfPanelInFocus"
			></app-round-button-left>

			<app-round-button-right
				(RightClick)="getOpenPdf()"
				[hidden]="this.pdfPanelInFocus"
			></app-round-button-right>
		</div>
	</div>

	<div [class]="this.commentsCss">
		<div class="card relative">
			<app-document-side-panel
				(addComment)="openCommentDialog()"
				[currentTask]="this.currentTask"
				[hasPrimaryDocument]="this.primaryFile.documentId !== undefined"
				[isPhobos]="false"
			></app-document-side-panel>
		</div>
	</div>
</div>
